import { render, staticRenderFns } from "./OrderPopover.vue?vue&type=template&id=51d4151a&scoped=true&"
import script from "./OrderPopover.vue?vue&type=script&lang=js&"
export * from "./OrderPopover.vue?vue&type=script&lang=js&"
import style0 from "./OrderPopover.vue?vue&type=style&index=0&id=51d4151a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4151a",
  null
  
)

export default component.exports